module.exports = __webpack_public_path__ + "static/media/invoicePendingRequirementsSecondStep.4a6e9971.png";